import { render, staticRenderFns } from "./SSelectOriginSupplies.vue?vue&type=template&id=202489b2"
import script from "./SSelectOriginSupplies.vue?vue&type=script&lang=js"
export * from "./SSelectOriginSupplies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports